import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Button, Typography } from "@mui/material";
import { createFileRoute, Link } from "@tanstack/react-router";

function PageError404(): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "grey.900",
        gap: "4rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "nowrap",
        }}
      >
        <img
          alt="layer1"
          height="356px"
          src="/assets/layer2.png"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "610px",
            flex: "1 1 30%",
            minWidth: "220px",
          }}
          width="610px"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
          paddingInline: "0.5rem",
        }}
      >
        <Typography
          color="white.main"
          fontWeight="600"
          textAlign="center"
          variant="body1"
        >
          <KeyboardArrowLeftIcon sx={{ marginBottom: "-6px" }} /> NÃO
          ENCONTRAMOS ESTA PÁGINA{" "}
          <KeyboardArrowRightIcon sx={{ marginBottom: "-6px" }} />
        </Typography>
        <img
          alt="comic"
          height="50px"
          src="/assets/comic-characters.png"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "50px",
          }}
          width="50px"
        />
        <Button
          color="error"
          component={Link}
          size="medium"
          sx={{ marginTop: "3rem" }}
          to="/"
          variant="outlined"
        >
          Voltar para o início
        </Button>
      </Box>
    </Box>
  );
}

export const Route = createFileRoute("/$")({
  component: PageError404,
});
